var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discovery-card"},[_c('h1',{staticClass:"title-text bold mb-4"},[_vm._v(_vm._s(_vm.titleText))]),_c('div',{staticClass:"title-text-2 roboto"},[_vm._v(_vm._s(_vm.descriptionText))])])}
var staticRenderFns = []

export { render, staticRenderFns }